import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['Martín', 'Camila', 'Facundo', 'Lucía', 'Santiago', 'Valentina', 'Mateo', 'Sofía', 'Joaquín', 'Agustina'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showNewBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNewBuyer = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    setCurrentBuyer({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (between 8 to 12 seconds)
      const nextDelay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(() => {
        showNewBuyer();
      }, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-176">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-177">
          <div className="bg-slate-800 border border-slate-700 shadow-2xl rounded-xl p-4 flex items-center gap-4" data-id="element-178">
            <div className="bg-cyan-500/20 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-179">
              <span className="text-xl" data-id="element-180">🛒</span>
            </div>
            <div data-id="element-181">
              <p className="text-sm text-slate-300" data-id="element-182">
                <span className="font-bold text-white" data-id="element-183">
                  {currentBuyer.name}
                </span>{' '}
                de {currentBuyer.city}
              </p>
              <p className="text-xs text-cyan-400 font-medium mt-0.5" data-id="element-184">
                Acaba de comprar KinesioTapingPro
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}